import ApplicationController from './application_controller';
import consumer from 'channels/consumer';

export default class extends ApplicationController {
  static targets = ["audio"]
  static values = {
    userId: String
  }
  
  connect() {
    const userId = this.userIdValue
    
    this.channel = consumer.subscriptions.create({
      channel: "ChatNotificationChannel",
      user_id: userId
    }, {
      connected: () => {
        console.log("ChatNotification subscription connected for user:", userId)
        // Uncomment to test audio on connection
        // this.handleNotification({})
      },
      disconnected: () => console.log("ChatNotification subscription disconnected"),
      rejected: () => console.log("ChatNotification subscription rejected"),
      received: (data) => {
        console.log("Received notification for user", userId, ":", data)
        this.handleNotification(data)
      }
    })
  }
  
  disconnect() {
    this.channel.unsubscribe()
  }
  
  handleNotification(data) {
    const audio = this.audioTarget
    console.log("Attempting to play audio...")
    console.log("Audio state:", {
      paused: audio.paused,
      currentTime: audio.currentTime,
      readyState: audio.readyState,
      duration: audio.duration
    })
    
    // Play the notification sound
    audio.play().then(() => {
      console.log("Audio playing successfully!")
    }).catch(error => {
      console.error("Error playing audio:", error)
    })
  }
}